import { Link } from 'react-router-dom';
import { routes } from '../../../core/routes';
import HousePulse from '../../../images/SideBar/pulsingHouse.png';
import { useEffect } from 'react';
import React, { useState } from "react";
import axios from "axios";
import { endpoints } from '../../../core/constants';
import { useTranslation } from "react-i18next";
import './MonitoredHouses.scss';

export default function MonitoredHouses() {
    //TRANSLATION INIT
  const { t } = useTranslation();

    const [houses, setHouses] = useState<number>(0);

    useEffect(() => {
        const headers = {
            //'cache': 'default',
            'mode': 'cors',
            'credentials': 'include',
            'content-type': 'application/json'
        };

        axios.get(endpoints.monitored_houses, { headers: headers, withCredentials: true })
            .then(response => {
                // SAVE IN SESSION NAMES OF MONITORED HOUSES
                sessionStorage.setItem('monitored_houses',  response.data.result.filter((f) => f.resource_contact.length > 0).map((m) => m.resource_contact));
                setHouses(response.data.result.filter((f) => f.resource_contact.length > 0).length);
            });
    }, []);

    return (
        <div className='MonitoredHouses'>
            <Link to={routes.map.url}>
                <img className='MonitoredHouses__image' src={HousePulse} alt='House icon with 3 concentric blue circles around it' />
                <span className='MonitoredHouses__number'>{houses}</span>
                <span className='MonitoredHouses__label'>{t("sidebar.monitoredHouses")}</span>
            </Link>
        </div>
    );
}